import { Client } from "@/Common/Api/Client";
import { Server } from "@/Common/Operations/operations.server";
import { ClientResponse } from "../ClientResponse";
import { IAddMedicationNoteRequest } from "./Dto/MedicationNotes/AddMedicationNoteRequest";
import { IAddMedicationNoteResponse } from "./Dto/MedicationNotes/AddMedicationNoteResponse";
import { MedicationNote } from "./Dto/MedicationNotes/MedicationNote";

class MedicationNotesClient {
    public static async addMedicationNote(request: IAddMedicationNoteRequest): Promise<ClientResponse<IAddMedicationNoteResponse>> {
        return await Client.postAsync<IAddMedicationNoteResponse>(
            Server.Myle_Patient_AddMedicationNote,
            request
        );
    }

    public static async getNotes(medicationNoteIds: string[]): Promise<MedicationNote[]> {
        const response = await Client.postAsync<{ MedicationNotes: MedicationNote[] }>(Server.Myle_Patient_GetMedicationNotes, {
            MedicationNoteIds: medicationNoteIds
        });

        if (!response.isSuccess) {
            sessionStore.showPopup(response.errors);
            return [];
        }

        return response.data.MedicationNotes;
    }
}

export { MedicationNotesClient };
